// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.spinner_container_DFjWw {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
}

.spinner_spinner_Myxb0 {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: 6px solid;
    border-color: var(--looks-secondary) transparent var(--looks-secondary) transparent;
    animation: spinner_spinner_Myxb0 1.2s linear infinite;
}

@keyframes spinner_spinner_Myxb0 {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-loading-spinner/spinner.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mFAAmF;IACnF,qDAAuC;AAC3C;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.container {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.spinner {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    border: 6px solid;\n    border-color: var(--looks-secondary) transparent var(--looks-secondary) transparent;\n    animation: spinner 1.2s linear infinite;\n}\n\n@keyframes spinner {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `spinner_container_DFjWw`;
export var spinner = `spinner_spinner_Myxb0`;
export default ___CSS_LOADER_EXPORT___;
